import { BaseProps } from '@/components/types'
import { MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { ReactNode, useEffect, useState } from 'react'
import { TableInputWrapper } from '../types/table'

function TableSelectBox ( props: TableSelectBoxProps ) {
    const {
        value = '', width, dataSource,
        onChange,
        ...rest
    } = props
    const [ input, setInput ] = useState( value )

    useEffect( () => {
        setInput( value )
    }, [ value ] )

    const onCustomChange = ( e: SelectChangeEvent<string>, child: ReactNode ) => {
        const { target } = e || {}
        const { value: targetValue } = target

        setInput( targetValue )
        onChange && onChange( targetValue )
    }

    return (
        dataSource && dataSource.length !== 0 && <div className="table-input-wrapper">
            <Select
                { ...rest }
                displayEmpty
                variant="outlined"
                value={ input }
                onChange={ onCustomChange }
                sx={ { width } }
            >
                {
                    dataSource.map( ( { value, name } ) => <MenuItem key={ `${ value }${ name }` } value={ value }>{ name }</MenuItem> )
                }
            </Select>
        </div>
    )
}

export default TableSelectBox

export interface SourceData {
    value: string
    name: any
    [ data: string ]: any
}


export interface lenderData {
    realEstateLmt: string
    addressLatitude: number
    addressLongitude: number
    samePersonLmtAmt: number
    jointLoanLmt: string
    kisunggoYn: string
}

export interface TableSelectBoxProps extends BaseProps, TableInputWrapper<string> {
    dataSource: SourceData[]
}